//
//
//
//
import echarts from 'echarts';
import tdTheme from './theme.json';
import { on, off } from '@/libs/tools';
import { chartMixins } from './chartMixins';
echarts.registerTheme('tdTheme', tdTheme);
export default {
  name: 'ChartBar',
  mixins: [chartMixins],
  props: {
    value: Array,
    text: String,
    subtext: String
  },
  data: function data() {
    return {
      dom: null
    };
  },
  methods: {
    resize: function resize() {
      this.dom.resize();
    },
    setParams: function setParams(value) {
      //let xAxisData = Object.values(value.xAxis);
      //let seriesData = Object.values(value.series)
      this.option = {
        title: {
          text: this.text,
          subtext: this.subtext,
          x: 'center'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '4%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#66cccc'
            }
          },
          splitLine: {
            show: false //data: xAxisData,

          }
        },
        yAxis: {
          splitLine: {
            show: false
          },
          axisLabel: {
            show: true,
            color: '#66cccc'
          },
          axisTick: {
            show: false
          },
          //不显示刻度
          axisLine: {
            show: true,
            color: '#66cccc',
            lineStyle: {
              color: '#66cccc'
            }
          }
        },
        series: [{
          type: 'bar',
          barWidth: 5,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: '#2d6e94'
            }, {
              offset: 0.5,
              color: '#2d6e94'
            }, {
              offset: 1,
              color: '#2d6e94'
            }])
          },
          data: value
        }]
      };
      return this.option;
    },
    init: function init() {
      this.dom = echarts.init(this.$refs.dom, 'tdTheme');
      this.dom.setOption(this.setParams(this.value));
      on(window, 'resize', this.resize);
    },
    setOption: function setOption(value) {
      this.dom.setOption(this.setParams(value));
    }
  },
  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    off(window, 'resize', this.resize);
  }
};